module.exports = __webpack_public_path__ + "img/seal.eec68f1a.svg";